<h1 mat-dialog-title>Error</h1>
<div mat-dialog-content>
  <p>{{ data.errorMessage || 'Your session has expired or you are not authorized to access this page.' }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onClose()">OK</button>
</div>
